import React from 'react';
import { Box, Chip } from '@mui/material';
import { useIntl } from 'react-intl';

import { IHelpSection } from '../models';
import { useHelpSections } from '../hooks';

import messages from './messages';

interface IProps {
  section: IHelpSection;
}

const HelpTags = ({ section }: IProps) => {
  const { isSectionNew } = useHelpSections();
  const { formatMessage } = useIntl();
  return (
    <Box display='flex'>
      {isSectionNew(section) ? (
        <Chip
          size='small'
          sx={{ marginLeft: '10px', fontSize: '10px' }}
          label={formatMessage(messages.newText)}
          color='primary'
        />
      ) : null}
    </Box>
  );
};

export default HelpTags;
